<template>
  <div class="accordion-item">
    <button
        class="accordion-button"
        :class="{ 'collapsed': !isExpanded }"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="`#${accordionId}`"
        :aria-expanded="isExpanded"
    >
      <slot name="header">
        <span>{{ title }}</span>
      </slot>
      <span v-if="showChevron" class="accordion-button-toggle ms-auto">
        <IconChevronDown :stroke="1" />
      </span>
    </button>
    <div
        :id="accordionId"
        class="accordion-collapse collapse"
        :class="{ 'show': isExpanded }"
        :data-bs-parent="parentId ? `#${parentId}` : undefined"
    >
      <div class="accordion-body" :class="bodyClass">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { IconChevronDown } from '@tabler/icons-vue';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  showChevron: {
    type: Boolean,
    default: true
  },
  expanded: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: null
  },
  parentId: {
    type: String,
    default: null
  },
  bodyClass: {
    type: String,
    default: ''
  }
});

const accordionId = computed(() => {
  if (props.id) return props.id;
  // Generate a unique ID based on title if not provided
  return `accordion-${props.title.replace(/\s+/g, '-').toLowerCase()}-${Math.random().toString(36).substr(2, 9)}`;
});

const isExpanded = computed(() => props.expanded);
</script>
